export default __webpack_public_path__ + "static/media/bg-section-1.7f9420d7.svg";